module.exports = __webpack_public_path__ + "img/home-dev.2134498d.png";